<kendo-expansionpanel title="{{ 'cf-document.expansion-panel.sign' | translate }}" [disabled]="disabled" style="width: 100%">
    <kendo-gridlayout [cols]="['40%', '60%']" [gap]="{ rows: 10, cols: 5 }" style="width: 100%">
        <kendo-gridlayout-item [col]="1" [row]="1">
            <label class="padding-right-10">{{ 'cf-signature.control.section' | translate }}</label>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [col]="2" [row]="1">
            <kendo-dropdownlist
                [data]="unsignedSections"
                [ngModel]="signatureStoreService.selectedSectionId"
                (ngModelChange)="selectSection($event)"
                [valuePrimitive]="true"
                textField="sectionName"
                valueField="sectionId"
                style="width: 100%">
            </kendo-dropdownlist>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [col]="1" [row]="2">
            <label class="padding-right-10">{{ 'cf-signature.control.signatureType' | translate }}</label>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [col]="2" [row]="2">
            <kendo-dropdownlist
                [data]="signatureTypes"
                [(ngModel)]="signatureStoreService.selectedSignatureType"
                [valuePrimitive]="true"
                textField="value"
                valueField="key"
                style="width: 100%">
            </kendo-dropdownlist>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [col]="1" [row]="3">
            <label class="padding-right-10">{{ 'cf-signature.control.signer' | translate }}</label>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [col]="2" [row]="3">
            <kendo-dropdownlist
                [data]="signersPerSection"
                [(ngModel)]="signatureStoreService.selectedSignerId"
                [valuePrimitive]="true"
                textField="username"
                valueField="participantId"
                style="width: 100%">
            </kendo-dropdownlist>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [col]="2" [row]="4">
            <kendo-buttongroup>
                <button
                    [disabled]="!signatureStoreService.areFiltersValid()"
                    style="width: 100%"
                    kendoButton
                    type="button"
                    themeColor="info"
                    title="{{ 'cf-signature.button.initiateSign' | translate }}"
                    (click)="initiateSignature()">
                    {{ 'cf-signature.button.initiateSign' | translate }}
                </button>
            </kendo-buttongroup>
        </kendo-gridlayout-item>
    </kendo-gridlayout>
</kendo-expansionpanel>
